<template>
    <div :class="['cl-checkbox', { 'cl-checkbox-active': checked }]" @click="handleClick">
        <img class="check-icon" :src="require('./icon/check.svg')" alt="" />
    </div>
</template>
<script>
export default {
    name: 'cl-checkbox',
    model: {
        event: 'input',
        prop: 'value',
    },
    props: {
        // v-model=“xxx” xxx的值
        value: {
            type: Boolean,
            default: false,
        },
        defaultValue: String,
    },
    data() {
        return {
            checked: false,
        };
    },
    watch: {
        defaultValue() {
            this.checked = !!this.defaultValue;
        },
        value: {
            handler(newval) {
                this.checked = newval;
            },
        },
    },
    mounted() {
        setTimeout(() => {
            if (this.defaultValue !== undefined) {
                this.checked = !!this.defaultValue;
                return;
            }
            this.checked = this.value;
            this.$emit('input', this.checked);
        });
    },
    methods: {
        // 多选框点击
        handleClick() {
            if (this.defaultValue !== undefined) {
                this.checked = !!this.defaultValue;
                return;
            }
            this.checked = !this.checked;
            this.$emit('input', this.checked);
            this.$emit('change', this.checked);
        },
    },
};
</script>
<style lang="scss" scoped>
.cl-checkbox {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    border: 1px solid #e9edf3;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
        border: 1px solid #3663e1;
    }
    .check-icon {
        width: 10px;
        transition: all 0.3s ease;
        transform: scale(0);
        user-select: none;
    }
}
.cl-checkbox-active {
    border: 1px solid #3663e1;
    background: #3663e1 !important;
    .check-icon {
        transform: scale(1);
    }
}
</style>
